<template>
  <div class="layout--full-page">
    <Header class="header" />
    <router-view></router-view>
  </div>
</template>
<script>
import Header from "./header.vue";
export default {
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.header {
  top: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
}
</style>
